import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

import { i18n } from '@/utils/i18n';

const validateWikiChangesSchema = Yup.object({
  emailAddress: Yup.string()
    .email(i18n.t('mix.valid_email'))
    .test('no-plus-sign', i18n.t('npoPaymentOnboarding.owner_form.emailAddress_no_plus'), (value) => {
      if (!value) return true;
      const [localPart] = value.split('@');
      return !localPart.includes('+');
    })
    .optional(),
  phone: Yup.string().optional()
});

export type ValidateWikiChangesData = Yup.InferType<typeof validateWikiChangesSchema>;

export const validateWikiChangesResolver = yupResolver(validateWikiChangesSchema);
